import { observable, action, decorate, computed } from 'mobx'
import axios from 'axios'
import beautify from 'xml-beautifier'

class NfeStore {
  constructor (rootStore) {
    this.state = {
      initialFetch: false,
      isFetching: true,
      date: new Date(),
      company: '',
      files: [],
      branch: 1,
      branches: [],
      searchKey: '',
      isSearching: false,
      xmlModal: {
        isActive: false,
        xml: new Map()
      },
      environments: ['QAS', 'PRD'],
      selectedEnvironment: 'QAS',
      types: ['Enviado', 'Recebido'],
      selectedTypes: ['Enviado'],
      certificate: {
        date: '',
        isFetching: false,
        isValid: null
      },
      order: 1
    }
    this.rootStore = rootStore.stores
  }

  get filteredFiles () {
    return this.state.files.filter(data => this.state.selectedTypes.includes(data.type))
  }

  get amountSent () {
    return this.state.files.filter(data => data.type === 'Enviado').length
  }

  get orderedFiles () {
    return this.filteredFiles.sort((current, next) => {
      const currentDate = new Date(current.LastModified)
      const nextDate = new Date(next.LastModified)
      if (this.state.order === 1) {
        if (currentDate.getTime() < nextDate.getTime()) {
          return -1
        }
        return 1
      } else {
        if (currentDate.getTime() > nextDate.getTime()) {
          return -1
        }
        return 1
      }
    })
  }

  toggleOrder () {
    this.state.order *= -1
  }

  fetchCertificate () {
    this.state.certificate.isFetching = true
    const url = 'https://8m0aihfcik.execute-api.us-east-2.amazonaws.com/QAS/verificacertificado/'
    axios.post(url, {
      cliente: this.state.company.toUpperCase()
    })
    .then(response => {
      this.state.certificate.date = new Date(response.data.data_formatojs)
      this.state.certificate.isValid = response.data.valido
      this.state.certificate.isFetching = false
    })
    .catch(error => {
      console.log(error)
      this.state.certificate.isFetching = false
    })
  }

  handleChange(value, name) {
    this.state[name] = value
    this.fetchBranches()
    this.fetchFiles()
  }

  toggleSelectedType (type) {
    if (!this.state.selectedTypes.includes(type)) {
      this.state.selectedTypes.push(type)
    } else {
      this.state.selectedTypes = this.state.selectedTypes.filter(data => data !== type)
    }
  }

  setSearchKey(searchKey) {
    this.state.searchKey = searchKey
  }

  closeModal () {
    this.state.xmlModal.isActive = false
  }

  openModal () {
    this.state.xmlModal.isActive = true
  }

  setCompany (company) {
    const cnpjCompany = this.rootStore.companiesStore.getCompany(company)
    if (cnpjCompany) {
      this.state.cnpj = cnpjCompany.cnpj
    }
    console.log(this.state.cnpj)
    this.state.company = company
    this.fetchBranches()
    this.fetchFiles()
    this.fetchCertificate()
  }

  setBranches(branches) {
    this.state.branches = branches
  }

  setBranch(branch) {
    this.state.branch = branch
  }

  setDate (date) {
    this.state.date = date
    this.fetchFiles()
  }

  setSelectedXml (key, lastModified) {
    this.state.xmlModal.xml.set('Key', key)
    this.state.xmlModal.xml.set('LastModified', lastModified)
  }

  setSelectedEnvironment (name) {
    this.state.selectedEnvironment = name
    this.fetchFiles()
  }

  searchXml () {
    this.state.isSearching = true
    if (this.state.searchKey.length !== 44) {
      this.state.isSearching = false
      this.rootStore.notificationStore.sendErrorNotification('Erro!', 'Digite uma chave válida')
      return
    }
    const url = process.env.REACT_APP_AWS_URL + '/searchXML/'
    axios.post(url, {
      company: this.state.company,
      branch: this.state.branch,
      environment: this.state.selectedEnvironment,
      key: this.state.searchKey
    })
    .then(response => {
      if (!response.data) {
        this.rootStore.notificationStore.sendErrorNotification('Ops!', 'Nenhum resultado encontrado')
      } else {
        this.setSelectedXml(response.data.Key, response.data.LastModified)
        this.getNfeBody()
        this.openModal()
      }
      this.state.isSearching = false
    })
    .catch(error => {
      console.log(error)
      this.state.isSearching = false
    })
  }

  fetchBranches () {
    const url = process.env.REACT_APP_AWS_URL + '/getCompanyBranches/'
    axios.post(url, {
      company: this.state.company,
    })
    .then(response => {
      this.state.branches = response.data
    })
    .catch(error => {
      console.log(error)
    })
  }

  fetchFiles () {
    this.state.isFetching = true
    this.state.initialFetch = true
    // const url = process.env.REACT_APP_AWS_URL + '/getSentXML/'
    const url = process.env.REACT_APP_AWS_URL + '/getNfeFiles'
    axios.post(url, {
      company: this.state.company,
      branch: this.state.branch,
      year: this.state.date.getFullYear(),
      month: pad(this.state.date.getMonth() + 1),
      day: this.state.date.getDate(),
      environment: this.state.selectedEnvironment
    })
    .then(response => {
      const sentFiles = response.data.sentFiles.map(data => {
        return {...data, type: 'Enviado'}
      })
      const receivedFiles = response.data.receivedFiles.map(data => {
        return {...data, type: 'Recebido'}
      })
      this.state.files = sentFiles.concat(receivedFiles).map(data => {
        return {...data, isDownloading: false, isViewing: false}
      })
      this.state.isFetching = false
    })
    .catch(error => {
      console.log(error)
      this.state.isFetching = false
    })
  }

  getNfeBody () {
    const currentKey = this.state.xmlModal.xml.get('Key')
    const currentFile = this.state.files.find(data => data.Key === currentKey)
    currentFile.isViewing = true
    const url = process.env.REACT_APP_AWS_URL + '/downloadXML/'
    axios.post(url, {
      key: currentKey
    })
    .then(response => {
      // this.state.xmlModal.xml.body = response.data
      this.state.xmlModal.xml.set('body', beautify(response.data))
      this.openModal()
      currentFile.isViewing = false
    })
    .catch(error => {
      console.log(error)
      currentFile.isViewing = false
    })
  }

  downloadNfe (key, name) {
    const currentFile = this.state.files.find(data => data.Key === key)
    currentFile.isDownloading = true
    const url = process.env.REACT_APP_AWS_URL + '/downloadXML/'
    axios.post(url, {
      key: key
    })
    .then(response => {
      download(name + '.xml', response.data)
      currentFile.isDownloading = false
    })
    .catch(error => {
      console.log(error)
      currentFile.isDownloading = false
    })
  }
}

const download = (filename, text) => {
  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

function pad(n){return n<10 ? '0'+n : n}

decorate(NfeStore, {
  state: observable,
  fetchFiles: action,
  filteredFiles: computed,
  amountSent: computed
})

export default NfeStore



// WEBPACK FOOTER //
// ./src/stores/products/nfeStore.js